/**
 * Notification type constants used throughout the app.
 * 
 * Note: Mobile and Desktop platforms use different notification preference keys:
 * 
 * DESKTOP SETTINGS (used in NotificationSettingsView.tsx):
 * - message: New message notifications
 * - upcomingEvent: Upcoming event reminders
 * - eventRsvp: RSVP reminder notifications
 * - bulletin: New bulletin notifications
 * 
 * MOBILE SETTINGS (used in MobileNotificationSettingsSection.tsx):
 * - rentReminders: Rent payment reminders
 * - maintenanceUpdates: Maintenance request updates
 * - communityUpdates: Community announcements and updates
 * 
 * This difference is intentional as each platform surfaces different features.
 * Mobile focuses on property management actions (rent, maintenance) while
 * desktop focuses on communication features (messages, events, bulletins).
 */
export const NOTIFICATION_TYPES = {
  // Desktop notification settings
  message: { key: 'message' },
  upcomingEvent: { key: 'upcomingEvent' },
  eventRsvp: { key: 'eventRsvp' },
  bulletin: { key: 'bulletin' },
  // Mobile notification settings
  rentReminders: { key: 'rentReminders' },
  maintenanceUpdates: { key: 'maintenanceUpdates' },
  communityUpdates: { key: 'communityUpdates' },
  // Marketplace notification types (used for filtering, not settings)
  marketplaceLeaveFeedback: { key: 'marketplace_leave_feedback' },
  marketplaceReceivedFeedback: { key: 'marketplace_received_feedback' },
  // Cork Board notification types
  corkBoardWarning: { key: 'cork_board_warning' },
} as const;

export type NotificationTypeKey = keyof typeof NOTIFICATION_TYPES;


export const NOTIFICATIONS_MAX_MARK = 25;